
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/inquiry/tarekomi",
      function () {
        return require("private-next-pages/inquiry/tarekomi/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/inquiry/tarekomi"])
      });
    }
  